import React, { useRef } from "react";
import HeroPage from "../assets/TOS Landing Page (1).png"; // Importing the right-side image
import EnergyBg from "../assets/energyBlueBg.png"; // Importing the background energy image
import Mbappe1 from "../assets/Salah 2.png"; // Importing the background energy image
import Mbappe2 from "../assets/Salah.png"; // Importing the background energy image
import HowItWorks from "./HowItWorks"; // Update the path
import bonusImage from "../assets/bonus-pic.png"; // Importing the background energy image

import { Link } from "react-router-dom";
import giftemoji from "../assets/giftemoji.png";

import HomeBuySection from "./HomeBuySection";

const HeroSection = () => {
  // Create a reference for HomeBuySection
  const buySectionRef = useRef(null);

  // Function to scroll to the HomeBuySection
  const scrollToBuySection = () => {
    buySectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const howItWorksRef = useRef(null);

  const handleScrollToHowItWorks = () => {
    howItWorksRef.current?.scrollIntoView({ behavior: "smooth" }); // Scroll to HowItWorks
  };

  return (
    <>
      <section className="relative bg-black text-white ">
        {/* Background Energy Image */}
        <div
          className="absolute inset-0 mr-[800px] pointer-events-none"
          style={{
            backgroundImage: `url(${EnergyBg})`,
            backgroundSize: "50%", // reduce size
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            opacity: 0.5,

          }}
        ></div>


        {/* Main Content */}

        <div className="relative bg-[#191919] text-white lg:hidden">
          {/* Energy Background */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url(${EnergyBg})`,
              backgroundSize: "40% auto", // Adjusts width while keeping aspect ratio
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              opacity: 0.35,
            }}
          ></div>

          {/* Left Image */}

          {/* Right Image */}
          <img
            src={Mbappe1}
            alt="Mbappe Right"
            className="absolute h-48 left-0 top-1/4 -translate-y-1/2 "
          />
          <img
            src={Mbappe2}
            alt="Mbappe Left"
            className="absolute h-48 right-0 top-1/4 -translate-y-1/2 "
          />

          {/* Main Content */}
          <div className="relative z-10 flex flex-col items-center text-center px-4 py-16">
            {/* Heading */}
            <p className="text-sm font-inter font-bold text-temp uppercase tracking-wide">
              Get Your
            </p>
            <h1 className="text-6xl font-monument font-extrabold text-white leading-none">
              FC
            </h1>
            <h1 className="text-6xl font-monument font-extrabold text-temp leading-none">
              2025
            </h1>
            <h1 className="text-[52px]  mr-4 ml-4 font-monument font-extrabold text-white leading-none">
              COINS
            </h1>

            {/* Subheading */}
            <p className="text-base font-inter mt-4 text-white">
              with the <span className="text-temp font-bold">fastest</span> delivery in
              just <span className="text-temp font-bold">20 minutes</span>
            </p>

            {/* Trustpilot Section */}
            <div className="mt-8">
              <a
                href="https://trustpilot.com/review/futcoinspot.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-temp text-black font-inter text-[12px]  font-bold px-12 py-3 rounded-full inline-block w-full text-center"
              >
                Check our 350+ reviews on  Trustpilot <span className="text-green-500 text-md">★</span>
              </a>
            </div>


            {/* Buttons */}
            <div className="flex space-x-4 mt-8">
              <div className="relative">
                {/* Bonus Image Above Trade Button (not clickable) */}
                <img
                  src={bonusImage}
                  alt="Bonus Banner"
                  className=" absolute -top-[44px] left-1/2 -translate-x-1/2 w-[120px] z-20 pointer-events-none"
                />

                {/* Trade button with proper shadow from the banner */}
                <button
                  className="bg-temp font-inter text-black font-bold px-12 py-3 rounded-full hover:bg-yellow-400 transition relative z-10 shadow-lg"
                  onClick={scrollToBuySection}
                >
                  Trade
                </button>
              </div>



              <Link
                to="/SellCoins"
                className="border-2 font-inter border-temp text-temp font-bold px-12 py-3 rounded-full hover:bg-temp hover:text-black transition"
              >
                Sell
              </Link>
            </div>


            {/* How It Works */}
            <button
              onClick={handleScrollToHowItWorks}
              className="flex items-center font-inter underline space-x-2 font-bold text-white hover:underline justify-center mt-8">
              <i className="fas fa-cog mr-2"></i>
              <span>Before you get started</span>
            </button>
          </div>
        </div>


        <div className="container  hidden mx-auto lg:flex flex-col lg:flex-row items-center justify-between relative z-10">
          {/* Left Content */}
          <div className="max-w-lg text-center lg:text-left lg:ml-20">
            {/* Supporting Header */}
            <p className="text-sm font-intertext-[24px] font-bold text-temp uppercase tracking-wide">
              Get Your
            </p>

            {/* Large Headline */}
            <div className="leading-none">
              <span className="block mt-1 text-[100px] font-monument   font-extrabold text-white">
                FC
              </span>
              <span className="block text-[100px] font-monument  font-extrabold text-temp">
                2025
              </span>
              <span className="block text-[100px] font-monument  font-extrabold text-white">
                COINS
              </span>
            </div>

            {/* Supporting Text */}
            <p className="text-base font-inter  lg:text-xl mt-4 text-white">
              with the <span className="text-temp font-bold">fastest</span> delivery in
              just <span className="text-temp font-bold">20 minutes</span>
            </p>

            {/* TrustPilot Section */}
            <div className="mt-4 text-center lg:text-left mb-12">
              <a
                href="https://trustpilot.com/review/futcoinspot.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-temp text-black  font-inter font-medium px-4 py-2 rounded-full inline-block"
              >
                Rated 4.9/5 on Trustpilot from 350+ Happy Customers
              </a>
            </div>


            {/* Buttons */}
            <div className="flex flex-row items-center justify-center lg:justify-start space-x-4 mt-6">
              <div className="relative">
                {/* Pink bonus banner with shadow effect */}
                <div className="relative">
                  {/* Bonus Image Above Trade Button (non-clickable) */}
                  <img
                    src={bonusImage}
                    alt="Bonus Banner"
                    className=" absolute -top-[44px] left-1/2 -translate-x-1/2 w-[130px] z-30 pointer-events-none"
                  />

                  {/* Trade button with shadow from the banner */}
                  <button
                    className="bg-temp font-inter text-[17px] w-32 text-black font-bold py-2 px-8 rounded-full hover:bg-yellow-300 transition relative z-20 shadow-md"
                    onClick={scrollToBuySection}
                  >
                    Trade
                  </button>
                </div>


              </div>

              <Link
                to="/SellCoins"
                className="border font-inter w-32 border-temp text-temp font-bold lg:px-8 lg:py-2 px-8 py-1 rounded-full hover:bg-temp hover:text-black transition flex items-center justify-center"
              >
                Sell
              </Link>

              <button
                onClick={handleScrollToHowItWorks}
                className="flex items-center font-inter space-x-1 font-bold text-white hover:underline justify-center"
              >
                <i className="fas fa-cog"></i> {/* FontAwesome Icon */}
                <span>Before you get started</span>
              </button>
            </div>

            <div className="flex flex-row items-center justify-center lg:justify-start space-x-4 mt-6">


            </div>
          </div>


          {/* Right Image */}
          <div className="mt-10 lg:mt-0 w-full  lg:max-w-lg lg:ml-20 hidden lg:flex md:flex">
            <img
              src={HeroPage}
              alt="Hero Section Right Side"
              className="w-full"
            />
          </div>
        </div>
      </section>

      {/* HomeBuySection Component */}
      <div ref={buySectionRef}>
        <HomeBuySection />
      </div>
      <div ref={howItWorksRef}>
        <HowItWorks />
      </div>
    </>
  );
};

export default HeroSection;


